{
  "el": {
    "dashboard": {
      "greetings": {
        "afternoon": "Καλό απόγευμα {first_name}",
        "evening": "Καλησπέρα {first_name}",
        "morning": "Καλημέρα {first_name}",
        "night": "Καληνύχτα {first_name}"
      },
      "milestones": {
        "caught_up_subtitle": "Δεν έχεις ανοιχτά θέματα αυτή τη στιγμή.",
        "caught_up_title": "Δεν εκκρεμεί τίποτα",
        "completed_count": "{count} ολοκληρωμένα",
        "due_before": "Πριν από {date}",
        "journey_no_active_subtitle": "Αυτό το ακίνητο δεν έχει ξεκινήσει ακόμη τη διαδρομή του.",
        "journey_no_active_title": "Κανένα ενεργό ορόσημο",
        "journey_select_unit_subtitle": "Διάλεξε ένα ακίνητο παραπάνω για να δεις τη διαδρομή του.",
        "journey_select_unit_title": "Επίλεξε ένα ακίνητο",
        "journey_title": "Η διαδρομή σου",
        "open_action": "Άνοιγμα",
        "previous_label": "Προηγούμενα ορόσημα",
        "progress_completed": "{completed} / {total} ολοκληρωμένα",
        "show_less": "Λιγότερα",
        "show_more_tasks": "Δείξε {count} ακόμη εργασία | Δείξε {count} ακόμη εργασίες",
        "status_active": "Σε εξέλιξη",
        "status_completed": "Ολοκληρώθηκε",
        "status_planned": "Προγραμματισμένο",
        "todo_now_title": "Τι να κάνεις τώρα",
        "upcoming_more": "{count} ακόμη επερχόμενα ορόσημα"
      },
      "titles": {
        "activityFeed": "Ιστορικό",
        "assignedTasks": "Οι εργασίες μου",
        "newsFeed": "Ανακοινώσεις",
        "ongoingTickets": "Σε εξέλιξη",
        "openTickets": "Ανοιχτές",
        "progress": "Πρόοδος",
        "tickets": "Συνομιλίες",
        "totalTickets": "Όλες οι συνομιλίες",
        "unreadTickets": "Μη αναγνωσμένες",
        "yourAssignedTickets": "Ανατεθειμένες σε σένα"
      }
    }
  }
}
